export const FILES_VISIBLE_COUNT = 3
